import * as React from "react";
const SvgFiRrKite = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-kite_svg__a)">
      <path
        fill="#062147"
        d="M18.76 16a5.2 5.2 0 0 0-3.707 1.535A15.14 15.14 0 0 1 4.273 22h-1.15a1.121 1.121 0 0 1-.793-1.914L5.52 16.9l11.768-3.138A5.005 5.005 0 0 0 21 8.927V5a5.006 5.006 0 0 0-5-5h-3.927a5.005 5.005 0 0 0-4.831 3.712L4.1 15.485.916 18.672A3.121 3.121 0 0 0 3.123 24h1.151a17.13 17.13 0 0 0 12.193-5.051A3.243 3.243 0 0 1 22 21.242V23a1 1 0 1 0 2 0v-1.758A5.25 5.25 0 0 0 18.76 16m-1.988-4.174-8.43 2.248L14.5 7.915l3.356 3.356c-.32.258-.688.447-1.084.555M19 5v3.927q-.003.3-.066.593l-3.02-3.02L18.7 3.716c.195.4.298.839.3 1.284m-6.927-3H16c.446.002.886.105 1.287.3L14.5 5.087l-3.02-3.021q.294-.063.593-.066m-2.9 2.228c.108-.396.297-.765.555-1.085L13.087 6.5l-6.162 6.163z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-kite_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrKite;
